import { useSyncExternalStore } from "react";

const PHONE = "(max-width: 767.98px)";

function subscribe(changed: () => void) {
  const m = window.matchMedia(PHONE);
  m.addEventListener("change", changed);
  return () => m.removeEventListener("change", changed);
}

/** Whether the screen is phone-wide (below Tailwind's md), following the window as it changes. */
export function usePhone(): boolean {
  return useSyncExternalStore(subscribe, () => window.matchMedia(PHONE).matches, () => false);
}
